const state = () => ({
  loading: false,
  successState: false,
  language: 'cs',
  showLanguageChangeNotification: false,
  mobileDialogLoading: false
});

const getters = {
  loading(state) {
    return state.loading;
  },
  successState(state) {
    return state.successState;
  },
  language(state) {
    return state.language;
  },
  showLanguageChangeNotification(state) {
    return state.showLanguageChangeNotification;
  },
  mobileDialogLoading(state) {
    return state.mobileDialogLoading;
  }
};

const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  setSuccess(state, payload) {
    state.successState = payload;
  },
  setLanguage(state, payload) {
    state.language = payload;
  },
  setShowLanguageChangeNotification(state, payload) {
    state.showLanguageChangeNotification = payload;
  },
  setMobileDialogLoading(state, payload) {
    state.mobileDialogLoading = payload;
  }
};

const actions = {
  setLoading({ commit }, payload) {
    commit('setLoading', payload);
  },
  setSuccess({ commit }, payload) {
    commit('setSuccess', payload);
  },
  setLanguage({ commit }, payload) {
    commit('setLanguage', payload);
  },
  setMobileDialogLoading({ commit }, payload) {
    commit('setMobileDialogLoading', payload);
  }
};

export const accountSettings = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
